import { MessagePlugin } from 'tdesign-vue-next'

import { getCurrentSemesterBySchoolId, getLevelRankDetail, getUserTypeSchoolList } from '@/api/home'

export function useTaskApi() {
  // 获取用户学校列表
  const fetchUserTypeSchoolList = (userId, userType) => {
    return new Promise((resolve, reject) => {
      getUserTypeSchoolList(userId, userType)
        .then((response) => {
          if (response.data.code === 0) {
            resolve(response.data.data || [])
          } else {
            MessagePlugin.error(response.data.msg)
            reject(response.data.msg)
          }
        })
        .catch((error) => {
          MessagePlugin.error('获取用户学校列表失败: ' + error.message)
          reject(error)
        })
    })
  }

  // 根据学校id获取当前学期
  const fetchCurrentSemesterBySchoolId = (schoolId) => {
    return new Promise((resolve, reject) => {
      getCurrentSemesterBySchoolId(schoolId)
        .then((response) => {
          if (response.data.code === 0) {
            resolve(response.data.data || {})
          } else {
            MessagePlugin.error(response.data.msg)
            reject(response.data.msg)
          }
        })
        .catch((error) => {
          MessagePlugin.error('获取当前学期失败: ' + error.message)
          reject(error)
        })
    })
  }

  // 获取用户等级和段位以及积分信息
  const fetchLevelRankDetail = (data) => {
    return new Promise((resolve, reject) => {
      getLevelRankDetail(data)
        .then((response) => {
          if (response.data.code === 0) {
            resolve(response.data.data || {})
          } else {
            MessagePlugin.error(response.data.msg)
            reject(response.data.msg)
          }
        })
        .catch((error) => {
          MessagePlugin.error('获取用户等级信息失败: ' + error.message)
          reject(error)
        })
    })
  }

  return {
    fetchUserTypeSchoolList,
    fetchCurrentSemesterBySchoolId,
    fetchLevelRankDetail,
  }
}
